import { Injectable, OnInit } from "@angular/core";
import { AbstractControl, ValidatorFn } from "@angular/forms";
import { FormUtlityCommanFunction } from "@mmortgage/dynamic-form";
import { localTempObject } from "@mmortgage/dynamic-form";
import { ConditionValidator } from "@mmortgage/dynamic-form";

@Injectable()
export class FormCustomValidatorFunctions implements OnInit {

    private custValidatorformUliFunObj: FormUtlityCommanFunction;
    private custValidatorempLocalObj: localTempObject;
    private lang: any;
    private parentObj: any;
    private condObj: ConditionValidator;

    ngOnInit(): void {
    }

    setCustValidatorIntValues(commFun: FormUtlityCommanFunction,
        tempObj: localTempObject, lang: any, parentObj: any, condObj: ConditionValidator) {
        this.custValidatorformUliFunObj = commFun;
        this.custValidatorempLocalObj = tempObj;
        this.parentObj = parentObj;
        this.lang = lang;
        this.condObj = condObj;
    }

    getCurrentValueObject() {
        try {
            let compDataObj = { compDataObj: this.parentObj.completeDataObj };
            let tempDatObj = this.parentObj.tempLocalObj;
            let dataObj = { data: this.parentObj.inpDataObj };
            let localData = { localData: this.parentObj.frameWork_Configuration.localData };
            this.condObj.InitValues(dataObj, tempDatObj, localData, compDataObj);
            return { tempDatObj: tempDatObj, dataObj: dataObj, localData: localData, compDataObj: compDataObj };
        } catch (e) {
        }
    }

    getCustomValidator(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            this.getCurrentValueObject();
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            let validatorName: string = custValObj.validatorName;
            let funName: any = this.condObj.setAndGetValue(validatorName);
            if (funName) {
                let retValue = funName(tempStr);
                let retObj = {
                    validatorName: '',
                    errorMsgObj: ''
                }
                if (retValue) {
                    retObj.validatorName = validatorName;
                    retObj.errorMsgObj = tempErrObj;
                    retObj[validatorName] = true;
                    return retObj;
                }
            } else {
                console.error("ERROR VALIDATOR FUNCTION NOT FOUND '", validatorName, "'");
            }
            return null
        }
    }

    AddressLineOne(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            // condtion check for number,space & text 
            if (!(/([0-9])+[A-Za-z]*([\s]{1})+([A-Za-z]+)/gi.test(tempStr))) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    AddressLineOne: true,
                    // below flag should be same as the function name.  
                    validatorName: 'AddressLineOne',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    EmailValidation(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
           
            let tempStr: string = controlObj.value;
            if (tempStr != "") {
                if (!(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/gi.test(tempStr))) {
                    // below object should be same for all custom validators.
                    return {
                        // below flag should be same as the function name.                                         
                        EmailValidation: true,
                        // below flag should be same as the function name.  
                        validatorName: 'EmailValidation',
                        errorMsgObj: tempErrObj
                    }
                }
                return null;
            } else {
                return null;
            }
        }
    }
    zipcodeForUS(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
           
            let tempStr: string = controlObj.value;
            if ((tempStr.length > 0 && tempStr.length < 5)
                || (tempStr.length > 5 && tempStr.length < 9)
                || (tempStr.length > 9)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    zipcodeForUS: true,
                    // below flag should be same as the function name.  
                    validatorName: 'zipcodeForUS',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    noDigits(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
           let tempStr: string = controlObj.value;
            if (/[0-9]/.test(tempStr)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    noDigits: true,
                    // below flag should be same as the function name.  
                    validatorName: 'noDigits',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    acceptOnlyNumbers(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
          
            let tempStr: string = controlObj.value;
            if (/[^0-9]/.test(tempStr) && tempStr !== ''
                && tempStr !== null && tempStr !== 'null') {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptOnlyNumbers: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptOnlyNumbers',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    acceptValue1_4Only(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempVal: number = Number(controlObj.value);
            if (tempVal < 1 || tempVal > 4) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptValue1_4Only: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptValue1_4Only',
                    errorMsgObj: tempErrObj
                }
            }
            return null;
        }
    }

    acceptValueUpto360(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempVal: number = Number(controlObj.value);
            if (tempVal <= 0 || tempVal > 360) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptValueUpto360: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptValueUpto360',
                    errorMsgObj: tempErrObj
                }
            }
            return null;
        }
    }

    acceptPosAndNegDecimals(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            if (isNaN(controlObj.value)) {
                return {
                    // below flag should be same as the function name.                                         
                    acceptPosAndNegDecimals: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptPosAndNegDecimals',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    ltvRestrict(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            if (parseFloat(controlObj.value) < 0 || parseFloat(controlObj.value) > 99.999) {
                return {
                    // below flag should be same as the function name.                                         
                    ltvRestrict: true,
                    // below flag should be same as the function name.  
                    validatorName: 'ltvRestrict',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }

    }

    restrictTotalPriorCharges(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            let tempVal: string;
            if (tempStr != null) {
                tempVal = this.custValidatorformUliFunObj.getOnlyCurrencyValue(tempStr, this.lang);
                if (parseFloat(tempVal) > 999999999.99) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictTotalPriorCharges: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictTotalPriorCharges',
                        errorMsgObj: tempErrObj
                    }
                }
            }
            return null
        }
    }

    restrictTotalPriorChargesAsWholeNumber(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
           
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            let tempVal: string;
            if (tempStr != null) {
                tempVal = tempStr.replace("$", "").replace(/,/g, '').replace(/ /g, '');
                if ((parseFloat(tempVal) > 999999999) || (tempVal.indexOf(".") != -1)) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictTotalPriorChargesAsWholeNumber: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictTotalPriorChargesAsWholeNumber',
                        errorMsgObj: tempErrObj
                    }
                }
            }
            return null
        }
    }

    acceptNumbersAndDecimalOnly(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (/[^0-9.]/.test(tempStr)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptNumbersAndDecimalOnly: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptNumbersAndDecimalOnly',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    acceptCharacterAndSpace(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (/[^A-zÀ-ÿ\s\-]/.test(tempStr)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.
                    acceptCharacterAndSpace: true,
                    // below flag should be same as the function name.
                    validatorName: 'acceptCharacterAndSpace',
                    errorMsgObj: tempErrObj
                };
            }
            return null;
        };
    }

    acceptOnlyCharacter(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (/[^A-zÀ-ÿ]/.test(tempStr)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptOnlyCharacter: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptOnlyCharacter',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    acceptOnlyPositiveNumbers(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (/[^0-9.]+/.test(tempStr)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    acceptOnlyPositiveNumbers: true,
                    // below flag should be same as the function name.  
                    validatorName: 'acceptOnlyPositiveNumbers',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    ageRestrict(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: number = Number(controlObj.value);
            if (tempStr > 99) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    ageRestrict: true,
                    // below flag should be same as the function name.  
                    validatorName: 'ageRestrict',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    ageRestrictTo18(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: any = controlObj.value;
            let currentYear = new Date().getFullYear();
            let birthYear = new Date(tempStr).getFullYear();
            if ((currentYear - birthYear) < 18) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.
                    ageRestrictTo18: true,
                    // below flag should be same as the function name.
                    validatorName: 'ageRestrictTo18',
                    errorMsgObj: tempErrObj
                }
            }
            return null;
        }
    }
    discountRestrict(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: number = Number(controlObj.value);
            if (tempStr < 0 || tempStr > 99.999) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    discountRestrict: true,
                    // below flag should be same as the function name.  
                    validatorName: 'discountRestrict',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }
    zeroRestrict(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: number = Number(controlObj.value);
            if (tempStr < 1) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    zeroRestrict: true,
                    // below flag should be same as the function name.  
                    validatorName: 'zeroRestrict',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }
    restricHolidays(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            try {
                let tempObj: any = this.custValidatorempLocalObj.temp;
                let configObj: any = this.parentObj.viewConfiObj;
                let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
                let fldValue: any = controlObj.value;
                let holidayList = tempObj.product_selection.holiday_list;
                let selectedDateStr = '';
                let monthsArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                if (fldValue && fldValue.date) {
                    let tempDateObj = fldValue.date;
                    selectedDateStr = (tempDateObj) ? (monthsArray[tempDateObj.month - 1] + ' ' + tempDateObj.day) : '';
                }
                let hasValue = holidayList.find(obj => (obj.keyValue.toLowerCase() === selectedDateStr.toLowerCase()));
                if (hasValue) {
                    // below object should be same for all custom validators.
                    return {
                        // below flag should be same as the function name.                                         
                        restricHolidays: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restricHolidays',
                        errorMsgObj: tempErrObj
                    }
                }
                return null
            } catch (e) {
            }
        }
    }

    fpdResctricDate(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            try {
                if (controlObj.parent) {
                    let tempObj: any = this.custValidatorempLocalObj.temp;
                    let configObj: any = this.parentObj.viewConfiObj;
                    let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
                    let fldValue: any = controlObj.value.date;
                    let payFreq_key = tempObj.product_selection.mortgage_product.payment_frequency_key;
                    let payFreq_value = tempObj.product_selection.mortgage_product.payment_frequency_value;
                    let DFR_dateObj = controlObj.parent.controls['B1_ProdDet_MortgageDetails_DateFundsRequired'].value.date;
                    let DFR_date: Date = new Date(Number(DFR_dateObj.year), Number(DFR_dateObj.month) - 1, Number(DFR_dateObj.day), 12, 0, 0);
                    let selectedDate: Date = new Date(Number(fldValue.year), Number(fldValue.month) - 1, Number(fldValue.day), 12, 0, 0);
                    let showError: boolean = false;


                    if (payFreq_value === "0") {
                        // for "Monthly"
                        // Rule DFR + 1 month and  DFR + 60 days
                        let fromDate: Date = new Date(DFR_date)
                        fromDate.setDate(DFR_date.getDate() + 30);
                        let toDate: Date = new Date(DFR_date)
                        toDate.setDate(DFR_date.getDate() + 60);

                        if (selectedDate >= fromDate && selectedDate <= toDate) {
                            showError = false;
                        } else {
                            showError = true;
                        }
                    } else if (payFreq_value === "1") {
                        // for "Semi-monthly"
                        let dfrDate: Date = new Date(DFR_date);
                        let fromDate: Date = new Date(DFR_date);
                        let toDate: Date = new Date(DFR_date);

                        if (dfrDate.getDate() < 14) {

                            fromDate.setDate(DFR_date.getDate() + 15);
                            toDate.setDate(DFR_date.getDate() + this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth() + 1));

                        } else if (dfrDate.getDate() > 15) {
                            fromDate.setDate(DFR_date.getDate() - 15 + this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth() + 1));
                            toDate.setDate(DFR_date.getDate() + this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth() + 1));
                        } else if (dfrDate.getDate() === 14 || dfrDate.getDate() === 15) {
                            /** Business Logic 
                             * or semi-monthly,  


                            if Month is February and day is 14th or 15th
                            between last day of the month and DFR + 1 Month
                            Otherwise
                            Between DFR + 15 days and DFR + 1 month
                             * 
                             * */


                            if (dfrDate.getMonth() === 1) { /* feburary */
                                fromDate.setDate(this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth()));
                                toDate.setDate(DFR_date.getDate() + this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth() + 1));
                            } else {
                                fromDate.setDate(DFR_date.getDate() + 15);
                                toDate.setDate(DFR_date.getDate() + this.getDaysInMonth(DFR_date.getFullYear(), DFR_date.getMonth() + 1));
                            }
                        }


                        if (selectedDate >= fromDate && selectedDate <= toDate) {
                            showError = false;
                        } else {
                            showError = true;
                        }

                    } else if (payFreq_value === "2") {
                        // for "Bi-weekly"
                        // Rule DFR + 14 days  and DFR + 28 days
                        let fromDate: Date = new Date(DFR_date)
                        fromDate.setDate(DFR_date.getDate() + 14);
                        let toDate: Date = new Date(DFR_date)
                        toDate.setDate(DFR_date.getDate() + 28);

                        if (selectedDate >= fromDate && selectedDate <= toDate) {
                            showError = false;
                        } else {
                            showError = true;
                        }
                    } else if (payFreq_value === "4") {
                        // for "Weekly" 
                        // Rule DFR + 7 days  and DFR + 14 days;
                        let fromDate: Date = new Date(DFR_date)
                        fromDate.setDate(DFR_date.getDate() + 7);
                        let toDate: Date = new Date(DFR_date)
                        toDate.setDate(DFR_date.getDate() + 14);

                        if (selectedDate >= fromDate && selectedDate <= toDate) {
                            showError = false;
                        } else {
                            showError = true;
                        }
                    }

                    if (showError) {
                        // below object should be same for all custom validators.
                        return {
                            // below flag should be same as the function name.                                         
                            fpdResctricDate: true,
                            // below flag should be same as the function name.  
                            validatorName: 'fpdResctricDate',
                            errorMsgObj: tempErrObj
                        }
                    }
                    return null
                }
            } catch (e) {
            }
        }
    }


    getDaysInMonth(year, month) {
        return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    };

    isLeapYear(year) {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    restrictPastDate_new(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempObj: any = this.custValidatorempLocalObj.temp;
            let fldValue: any = controlObj.value.date;
            let payFreqValu = tempObj.product_selection.mortgage_product.payment_frequency;
            let selectedDateStr = '';
            if (controlObj.value && controlObj.value.date) {
                selectedDateStr = (fldValue) ? fldValue.year + '-' + fldValue.month + '-' + fldValue.day : '';
            }
            if (fldValue < 1) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    restrictPastDate: true,
                    // below flag should be same as the function name.  
                    validatorName: 'restrictPastDate',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    restrictPastDate(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
          
            let selectedDateStr: string = '';
            // ------------------------------------------------
            // Has been changed bcoz, now we have implement 'my-date-picker' component for I.E support.   
            if (controlObj.value && controlObj.value.date) {
                let tempDateObj = controlObj.value.date;
                selectedDateStr = (tempDateObj) ? tempDateObj.year + '-' + tempDateObj.month + '-' + tempDateObj.day : '';
            }
            // *********************************************

            let currentDate: Date = new Date();
            //null, and undefined check
            if (selectedDateStr != null && selectedDateStr.split("-").length == 3) {
                //input : Lets say 11Feb2018 : 2019-02-11
                //We are setting time as 12:00:00 to handle any issue with GMT+0000 and GMT-5000
                //example: let selectedDate: Date = new Date(2019,1,11,12,0,0);
                let selectedDateYYYYMMDD = selectedDateStr.split("-");
                let selectedDate: Date = new Date(Number(selectedDateYYYYMMDD[0]), Number(selectedDateYYYYMMDD[1]) - 1, Number(selectedDateYYYYMMDD[2]), 12, 0, 0);
                if (selectedDate.getDay() == 6 || selectedDate.getDay() == 0) {
                    return {
                        restrictPastDate: true,
                        validatorName: 'restrictPastDate',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() > selectedDate.getFullYear()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDate',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() > selectedDate.getMonth()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDate',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() == selectedDate.getMonth() && currentDate.getDate() > selectedDate.getDate()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDate',
                        errorMsgObj: tempErrObj
                    };
                }
            }
            return null

        }
    }

    maxDigitRestriction(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];

             if (this.lang == 'en' && controlObj.value && (controlObj.value.indexOf(".") && controlObj.value.replace("$", "").replace(/,/g, '').replace(/ /g, '').split(".")[0].length > 7)) {

                return {
                    // below flag should be same as the function name.                                         
                    maxDigitRestriction: true,
                    // below flag should be same as the function name.  
                    validatorName: 'maxDigitRestriction',
                    errorMsgObj: tempErrObj
                };
            }

            else if (this.lang == 'en' && controlObj.value && (!controlObj.value.indexOf(".") && controlObj.value.replace("$", "").replace(/,/g, '').replace(/ /g, '').length > 7)) {

                return {
                    // below flag should be same as the function name.                                         
                    maxDigitRestriction: true,
                    // below flag should be same as the function name.  
                    validatorName: 'maxDigitRestriction',
                    errorMsgObj: tempErrObj
                };
            }

            if (this.lang == 'fr' && controlObj.value && (controlObj.value.indexOf(",") && controlObj.value.replace("$", "").replace(/ /g, '').split(",")[0].length > 7)) {

                return {
                    // below flag should be same as the function name.                                         
                    maxDigitRestriction: true,
                    // below flag should be same as the function name.  
                    validatorName: 'maxDigitRestriction',
                    errorMsgObj: tempErrObj
                };
            }

            else if (this.lang == 'fr' && controlObj.value && (!controlObj.value.indexOf(",") && controlObj.value.replace("$", "").replace(/ /g, '').length > 7)) {

                return {
                    // below flag should be same as the function name.                                         
                    maxDigitRestriction: true,
                    // below flag should be same as the function name.  
                    validatorName: 'maxDigitRestriction',
                    errorMsgObj: tempErrObj
                };
            }

            return null

        }
    }


    restrictFutureDate(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
             let currentDate: Date = new Date();

            let selectedDateStr: string = '';
            // ------------------------------------------------
            // Has been changed bcoz, now we have implement 'my-date-picker' component for I.E support.  
            if (controlObj.value && controlObj.value.date) {
                let tempDateObj = controlObj.value.date;
                selectedDateStr = (tempDateObj) ? tempDateObj.year + '-' + tempDateObj.month + '-' + tempDateObj.day : '';
            }
            // *********************************************



            //null, and undefined check
            if (selectedDateStr != null && selectedDateStr.split("-").length == 3) {
                //input : Lets say 11Feb2018 : 2019-02-11
                //We are setting time as 12:00:00 to handle any issue with GMT+0000 and GMT-5000
                //example: let selectedDate: Date = new Date(2019,1,11,12,0,0);
                let selectedDateYYYYMMDD = selectedDateStr.split("-");
                let selectedDate: Date = new Date(Number(selectedDateYYYYMMDD[0]), Number(selectedDateYYYYMMDD[1]) - 1, Number(selectedDateYYYYMMDD[2]), 12, 0, 0);
                if (currentDate.getFullYear() < selectedDate.getFullYear()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictFutureDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictFutureDate',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() < selectedDate.getMonth()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictFutureDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictFutureDate',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() == selectedDate.getMonth() && currentDate.getDate() < selectedDate.getDate()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictFutureDate: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictFutureDate',
                        errorMsgObj: tempErrObj
                    };
                }
            }
            return null

        }
    }
    isGreaterThanDFR(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
           

            let selectedDateStr: string = '';
            // ------------------------------------------------
            // Has been changed bcoz, now we have implement 'my-date-picker' component for I.E support.   
            if (controlObj.value && controlObj.value.date) {
                let tempDateObj = controlObj.value.date;
                selectedDateStr = (tempDateObj) ? tempDateObj.year + '-' + tempDateObj.month + '-' + tempDateObj.day : '';
            }
            // *********************************************


            if (selectedDateStr != null && selectedDateStr.split("-").length == 3) {

                let selectedDateYYYYMMDD = selectedDateStr.split("-");
                let selectedDate: Date = new Date(Number(selectedDateYYYYMMDD[0]), Number(selectedDateYYYYMMDD[1]) - 1, Number(selectedDateYYYYMMDD[2]), 12, 0, 0);

                let dfrStr;
                let dfrDate: Date;
                if (controlObj.parent != null) {
                    if (controlObj.parent.controls['B1_ProdDet_MortgageDetails_DateFundsRequired'] != null &&
                        controlObj.parent.controls['B1_ProdDet_MortgageDetails_DateFundsRequired'].value &&
                        selectedDateStr.length == 10) {
                        dfrStr = controlObj.parent.controls['B1_ProdDet_MortgageDetails_DateFundsRequired'].value.split("-");
                        dfrDate = new Date(Number(dfrStr[0]), Number(dfrStr[1]) - 1, Number(dfrStr[2]), 12, 0, 0);
                        if (selectedDate.getFullYear() < dfrDate.getFullYear()) {
                            return {
                                // below flag should be same as the function name.                                         
                                isGreaterThanDFR: true,
                                // below flag should be same as the function name.  
                                validatorName: 'isGreaterThanDFR',
                                errorMsgObj: tempErrObj
                            }
                        }
                        else if (selectedDate.getFullYear() == dfrDate.getFullYear() && selectedDate.getMonth() < dfrDate.getMonth()) {
                            return {
                                // below flag should be same as the function name.                                         
                                isGreaterThanDFR: true,
                                // below flag should be same as the function name.  
                                validatorName: 'isGreaterThanDFR',
                                errorMsgObj: tempErrObj
                            }
                        }
                        else if (selectedDate.getFullYear() == dfrDate.getFullYear() && selectedDate.getMonth() == dfrDate.getMonth() && selectedDate.getDate() <= dfrDate.getDate()) {
                            return {
                                // below flag should be same as the function name.                                         
                                isGreaterThanDFR: true,
                                // below flag should be same as the function name.  
                                validatorName: 'isGreaterThanDFR',
                                errorMsgObj: tempErrObj
                            }
                        }
                    }
                }

            }
            return null
        }
    }

    restrictAmortizationYears(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempObj: any = this.custValidatorempLocalObj.temp;
            let paymentAmortizationStr: string = controlObj.value;

            if (paymentAmortizationStr !== undefined && paymentAmortizationStr !== null) {

                let regAmortizationMonths;//regAmortizationMonths
                let paymentAmortizationMonths; // paymentAmortizationMonths
                let baseParent = controlObj.parent;
                let durationTerm = '0';

                if (tempObj.product_selection.mortgage.product_selection_term !== undefined &&
                    tempObj.product_selection.mortgage.product_selection_term !== null) {
                    durationTerm = tempObj.product_selection.mortgage.product_selection_term;
                }
                if (baseParent && baseParent.parent !== undefined && baseParent.parent != null) {
                    if (baseParent.parent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'] != null &&
                        baseParent.parent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value &&
                        baseParent.parent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value.length > 0) {
                        regAmortizationMonths = baseParent.parent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value;

                        if (baseParent.controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Years'].value &&
                            baseParent.controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Months'].value) {
                            let PaymentAmortization_Years = baseParent.controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Years'].value;
                            let PaymentAmortization_Months = baseParent.controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Months'].value;
                            paymentAmortizationMonths = ((parseFloat(PaymentAmortization_Years) * 12) + (parseFloat(PaymentAmortization_Months)));
                        }

                        if ((parseFloat(regAmortizationMonths) < (parseFloat(paymentAmortizationMonths))) ||
                            ((parseFloat(paymentAmortizationMonths)) < (parseFloat(durationTerm)))) {
                            return {
                                // below flag should be same as the function name.                                         
                                restrictAmortizationYears: true,
                                // below flag should be same as the function name.  
                                validatorName: 'restrictAmortizationYears',
                                errorMsgObj: tempErrObj
                            }
                        }
                       
                       
                    }
                }

            }
            return null
        }
    }
    restrictRegisteredAmortization(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let tempObj: any = this.custValidatorempLocalObj.temp;
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let paymentAmortizationStr: string = controlObj.value;


            if (Number(controlObj.value) > 360) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    restrictRegisteredAmortization: true,
                    // below flag should be same as the function name.  
                    validatorName: 'restrictRegisteredAmortization',
                    errorMsgObj: tempErrObj
                }
            }
            else if (paymentAmortizationStr !== undefined && paymentAmortizationStr !== null) {
                custValObj.validatorErrMsg = "restrictRegisteredAmortizationYearErrMsg";

                let regAmortizationMonths;//regAmortizationMonths
                let paymentAmortizationMonths; // paymentAmortizationMonths
                let baseParent = controlObj.parent;
                let durationTerm = '0';

                if (tempObj.product_selection.mortgage.product_selection_term !== undefined &&
                    tempObj.product_selection.mortgage.product_selection_term !== null) {
                    durationTerm = tempObj.product_selection.mortgage.product_selection_term;
                }
                if (baseParent && baseParent !== undefined) {
                    if (baseParent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'] != null &&
                        baseParent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value &&
                        baseParent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value.length > 0) {
                        regAmortizationMonths = baseParent.controls['B1_ProdDet_MortgageProduct_RegisteredAmortizationMonths'].value;

                        //baseParent.controls["B1_ProdDet_MortgageProduct_PaymentAmortization"].controls["B1_ProdDet_MortgageProduct_PaymentAmortization_Years"].value

                        if (baseParent.controls["B1_ProdDet_MortgageProduct_PaymentAmortization"].controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Years'].value &&
                            baseParent.controls["B1_ProdDet_MortgageProduct_PaymentAmortization"].controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Months'].value) {
                            let PaymentAmortization_Years = baseParent.controls["B1_ProdDet_MortgageProduct_PaymentAmortization"].controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Years'].value;
                            let PaymentAmortization_Months = baseParent.controls["B1_ProdDet_MortgageProduct_PaymentAmortization"].controls['B1_ProdDet_MortgageProduct_PaymentAmortization_Months'].value;
                            paymentAmortizationMonths = ((parseFloat(PaymentAmortization_Years) * 12) + (parseFloat(PaymentAmortization_Months)));
                        }

                        //paymentAmortizationMonths = (parseFloat(paymentAmortizationStr)*12);
                        if ((parseFloat(regAmortizationMonths) < (parseFloat(paymentAmortizationMonths))) ||
                            ((parseFloat(paymentAmortizationMonths)) < (parseFloat(durationTerm)))) {
                            return {
                                // below flag should be same as the function name.                                         
                                restrictRegisteredAmortization: true,
                                // below flag should be same as the function name.  
                                validatorName: 'restrictRegisteredAmortization',
                                errorMsgObj: tempErrObj
                                //errorMsgObj: 'restrictRegisteredAmortizationYearErrMsg'
                            }
                        }
                    }
                }

            }
            return null
        }
    }

    restrictFutureYear(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempYear: number = Number(controlObj.value);
            if (tempYear > (new Date()).getFullYear()) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    restrictFutureYear: true,
                    // below flag should be same as the function name.  
                    validatorName: 'restrictFutureYear',
                    errorMsgObj: tempErrObj
                };
            }
            return null
        }
    }


    paymentDay(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: number = Number(controlObj.value);
            if (tempStr > 31 || tempStr.toString() === '0') {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    paymentDay: true,
                    // below flag should be same as the function name.  
                    validatorName: 'paymentDay',
                    errorMsgObj: tempErrObj
                }
            }
            return null
        }
    }

    PRPIDValidator(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (!(/M[0-9]{8,8}/.test(tempStr))) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    PRPIDValidator: true,
                    // below flag should be same as the function name.  
                    validatorName: 'PRPIDValidator',
                    errorMsgObj: tempErrObj
                };
            }
            return null;
        };
    }
    ReferralCodeBranchValidator(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (!(/BR[0-9]{5,5}/.test(tempStr))) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    ReferralCodeBranchValidator: true,
                    // below flag should be same as the function name.  
                    validatorName: 'ReferralCodeBranchValidator',
                    errorMsgObj: tempErrObj
                };
            }
            return null;
        };
    }
    ReferralCodeBRPValidator(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempStr: string = controlObj.value;
            if (!(/1[A-Z]{2,2}[0-9]{3,5}/.test(tempStr))) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    ReferralCodeBRPValidator: true,
                    // below flag should be same as the function name.  
                    validatorName: 'ReferralCodeBRPValidator',
                    errorMsgObj: tempErrObj
                };
            }
            return null;
        };
    }
    restrictPastDateWeekAllowed(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let selectedDateStr: string = '';
            // ------------------------------------------------
            // Has been changed bcoz, now we have implement 'my-date-picker' component for I.E support.        
            if (controlObj.value && controlObj.value.date) {
                let tempDateObj = controlObj.value.date;
                selectedDateStr = (tempDateObj) ? tempDateObj.year + '-' + tempDateObj.month + '-' + tempDateObj.day : '';
            }
            // *********************************************

            let currentDate: Date = new Date();

            //null, and undefined check
            if (selectedDateStr != null && selectedDateStr.split("-").length == 3) {
                //input : Lets say 11Feb2018 : 2019-02-11
                //We are setting time as 12:00:00 to handle any issue with GMT+0000 and GMT-5000
                //example: let selectedDate: Date = new Date(2019,1,11,12,0,0);
                let selectedDateYYYYMMDD = selectedDateStr.split("-");
                let selectedDate: Date = new Date(Number(selectedDateYYYYMMDD[0]), Number(selectedDateYYYYMMDD[1]) - 1, Number(selectedDateYYYYMMDD[2]), 12, 0, 0);
                if (currentDate.getFullYear() > selectedDate.getFullYear()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDateWeekAllowed: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDateWeekAllowed',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() > selectedDate.getMonth()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDateWeekAllowed: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDateWeekAllowed',
                        errorMsgObj: tempErrObj
                    };
                }
                else if (currentDate.getFullYear() == selectedDate.getFullYear() && currentDate.getMonth() == selectedDate.getMonth() && currentDate.getDate() > selectedDate.getDate()) {
                    return {
                        // below flag should be same as the function name.                                         
                        restrictPastDateWeekAllowed: true,
                        // below flag should be same as the function name.  
                        validatorName: 'restrictPastDateWeekAllowed',
                        errorMsgObj: tempErrObj
                    };
                }
            }
            return null

        }
    }

    propertyAgeRestrict(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            if (controlObj.parent != null) {
                if (controlObj.parent.controls['B1_Property_Details_NewConstruction'] != null &&
                    controlObj.parent.controls['B1_Property_Details_NewConstruction'].value &&
                    controlObj.parent.controls['B1_Property_Details_NewConstruction'].value.length > 0) {

                    let durationTerm = controlObj.parent.controls['B1_Property_Details_NewConstruction'].value;
                    let configObj: any = this.parentObj.viewConfiObj;
                    let tempErrObj: any;
                    let tempStr: number = Number(controlObj.value);
                    if (durationTerm === 'Y' && (tempStr > 3)) {
                        // below object should be same for all custom validators.
                        tempErrObj = configObj.errorMessages['propertyAgeRestrictNewErrMsg'];
                        return {
                            // below flag should be same as the function name.                              
                            propertyAgeRestrict: true,
                            // below flag should be same as the function name.  
                            validatorName: 'propertyAgeRestrict',
                            errorMsgObj: tempErrObj
                        }
                    } else if (durationTerm === 'N' && (tempStr.toString() === '0')) {
                        // below object should be same for all custom validators.
                        tempErrObj = configObj.errorMessages['propertyAgeRestrictNewErrMsg'];
                        return {
                            // below flag should be same as the function name.                                         
                            propertyAgeRestrict: true,
                            // below flag should be same as the function name.  
                            validatorName: 'propertyAgeRestrict',
                            errorMsgObj: tempErrObj
                        }
                    }
                }
            }
            return null
        }
    }

    restrictBlendedMaturityDate(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let tempObj: any = this.custValidatorempLocalObj.temp;
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let selectedDateStr: string = '';
            // ------------------------------------------------
            // Has been changed bcoz, now we have implement 'my-date-picker' component for I.E support.   
            if (controlObj.value && controlObj.value.date) {
                let tempDateObj = controlObj.value.date;
                selectedDateStr = (tempDateObj) ? tempDateObj.year + '-' + tempDateObj.month + '-' + tempDateObj.day : '';
            }
            // *********************************************


            if (selectedDateStr != null && selectedDateStr.split("-").length == 3) {

                let selectedDateYYYYMMDD = selectedDateStr.split("-");
                let selectedDate: Date = new Date(Number(selectedDateYYYYMMDD[0]), Number(selectedDateYYYYMMDD[1]) - 1, Number(selectedDateYYYYMMDD[2]), 12, 0, 0);

                let dfrStr;
                let dfrDate: Date;
                let selLibMaturityDate;


                let baseParent = controlObj.parent;

                if (tempObj.product_selection.mortgage.maturity_date !== undefined &&
                    tempObj.product_selection.mortgage.maturity_date !== null) {
                    selLibMaturityDate = tempObj.product_selection.mortgage.maturity_date;
                }

                if (selLibMaturityDate && selLibMaturityDate !== undefined && selLibMaturityDate != null) {
                    if (selLibMaturityDate != null &&
                        selLibMaturityDate) {
                        dfrStr = selLibMaturityDate.split("-");
                        dfrDate = new Date(Number(dfrStr[0]), Number(dfrStr[1]) - 1, Number(dfrStr[2]), 12, 0, 0);
                        if (selectedDate.getFullYear() > dfrDate.getFullYear()) {
                            return {
                                // below flag should be same as the function name.                                         
                                restrictBlendedMaturityDate: true,
                                // below flag should be same as the function name.  
                                validatorName: 'restrictBlendedMaturityDate',
                                errorMsgObj: tempErrObj
                            }
                        }
                        else if (selectedDate.getFullYear() == dfrDate.getFullYear() && selectedDate.getMonth() > dfrDate.getMonth()) {
                            return {
                                // below flag should be same as the function name.                                         
                                restrictBlendedMaturityDate: true,
                                // below flag should be same as the function name.  
                                validatorName: 'restrictBlendedMaturityDate',
                                errorMsgObj: tempErrObj
                            }
                        }
                        else if (selectedDate.getFullYear() == dfrDate.getFullYear() && selectedDate.getMonth() == dfrDate.getMonth() && selectedDate.getDate() > dfrDate.getDate()) {
                            return {
                                // below flag should be same as the function name.                                         
                                restrictBlendedMaturityDate: true,
                                // below flag should be same as the function name.  
                                validatorName: 'restrictBlendedMaturityDate',
                                errorMsgObj: tempErrObj
                            }
                        }
                    }
                }

            }
            return null
        }
    }

    restrictTaxYear(custValObj: any): ValidatorFn {
        return (controlObj: AbstractControl) => {
            let configObj: any = this.parentObj.viewConfiObj;
            let tempErrObj: any = configObj.errorMessages[custValObj.validatorErrMsg];
            let tempYear: number = Number(controlObj.value);
            if (tempYear < ((new Date()).getFullYear() - 5)) {
                // below object should be same for all custom validators.
                return {
                    // below flag should be same as the function name.                                         
                    restrictTaxYear: true,
                    // below flag should be same as the function name.  
                    validatorName: 'restrictTaxYear',
                    errorMsgObj: tempErrObj
                };
            }
            return null
        }
    }

}
